import { useMutation, useQueryClient } from '@tanstack/react-query'
import { uploadBulkImportCsv } from '../../../api/plan-override-bulk-imports-api'
import type { BulkImportSessionResponseDto } from '../../../api/dto/bulk-import-session.dto'

export const BULK_IMPORT_SESSIONS_QUERY_KEY = 'bulkImportSessions'

interface BulkImportCsvVariables {
  file: File
}

export function useBulkImportCsv() {
  const queryClient = useQueryClient()

  return useMutation<
    BulkImportSessionResponseDto,
    unknown,
    BulkImportCsvVariables
  >({
    mutationFn: ({ file }) => uploadBulkImportCsv(file, 'plan-benefit'),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [BULK_IMPORT_SESSIONS_QUERY_KEY, 'plan-benefit'],
      })
    },
  })
}
